import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

const STATUSES = ["New", "Contacted", "Qualified", "Converted", "Lost"];
const SOURCE_LABELS = {
  atelier_pre_registration: "Atölye Ön Kayıt", individual_program: "Program", institutional: "Kurumsal",
  newsletter: "Mektup", contact: "İletişim",
};

export default function LeadManager() {
  const [leads, setLeads] = useState([]);
  const [filter, setFilter] = useState("");
  const [selected, setSelected] = useState(null);
  const [note, setNote] = useState("");

  const load = () => {
    const params = filter ? { status: filter } : {};
    api.get("/admin/leads", { params }).then(({ data }) => setLeads(data)).catch(() => {});
  };
  useEffect(() => { load(); }, [filter]);

  const updateStatus = async (id, status) => {
    await api.put(`/admin/leads/${id}`, { status });
    toast.success("Durum güncellendi.");
    load();
  };
  const saveNote = async () => {
    await api.put(`/admin/leads/${selected.id}`, { note });
    toast.success("Not kaydedildi.");
    setSelected(null); load();
  };

  return (
    <div data-testid="admin-leads">
      <h1 className="font-serif text-4xl text-brand-green mb-6">Lead Yönetimi</h1>
      <div className="flex gap-2 mb-6 flex-wrap">
        <button onClick={() => setFilter("")} className={`px-4 py-2 text-sm rounded-full border ${!filter ? "bg-brand-green text-brand-offwhite" : "bg-brand-offwhite border-brand-gold-light/40"}`}>Tümü</button>
        {STATUSES.map((s) => (
          <button key={s} onClick={() => setFilter(s)} className={`px-4 py-2 text-sm rounded-full border ${filter === s ? "bg-brand-green text-brand-offwhite" : "bg-brand-offwhite border-brand-gold-light/40"}`}>{s}</button>
        ))}
      </div>

      <div className="bg-brand-offwhite border border-brand-gold-light/40 rounded-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-brand-cream text-brand-green text-left">
            <tr>
              <th className="p-3 font-medium">Kaynak</th><th className="p-3 font-medium">İsim</th>
              <th className="p-3 font-medium">İletişim</th><th className="p-3 font-medium">Program</th>
              <th className="p-3 font-medium">Tarih</th><th className="p-3 font-medium">Durum</th><th className="p-3 font-medium">Not</th>
            </tr>
          </thead>
          <tbody>
            {leads.map((l) => (
              <tr key={l.id} data-testid={`lead-row-${l.id}`} className="border-t border-brand-gold-light/30">
                <td className="p-3"><span className="text-xs bg-brand-cream px-2 py-1 rounded">{SOURCE_LABELS[l.source] || l.source}</span></td>
                <td className="p-3 font-medium text-brand-green">{l.name}<br /><span className="text-xs text-brand-text/50">{l.organization}</span></td>
                <td className="p-3 text-brand-text/70">{l.email}<br />{l.phone}</td>
                <td className="p-3 text-brand-text/70">{l.program || l.category || "-"}</td>
                <td className="p-3 text-brand-text/50 text-xs">{(l.created_at || "").slice(0, 10)}</td>
                <td className="p-3">
                  <select value={l.status} onChange={(e) => updateStatus(l.id, e.target.value)} data-testid={`lead-status-${l.id}`}
                    className="text-xs border border-brand-gold-light/50 rounded px-2 py-1 bg-white">
                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
                <td className="p-3">
                  <button onClick={() => { setSelected(l); setNote(l.admin_note || ""); }} className="text-xs text-brand-gold underline">Not</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {leads.length === 0 && <p className="p-6 text-brand-text/50 text-sm">Lead bulunmuyor.</p>}
      </div>

      {selected && (
        <div className="fixed inset-0 bg-brand-green/50 flex items-center justify-center z-50 p-6" onClick={() => setSelected(null)}>
          <div className="bg-brand-offwhite rounded-sm p-8 max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <h3 className="font-serif text-2xl text-brand-green mb-1">{selected.name}</h3>
            <p className="text-sm text-brand-text/60 mb-4">{selected.email} · {selected.phone}</p>
            {selected.message && <p className="text-sm bg-brand-cream p-4 rounded mb-4">{selected.message}</p>}
            <label className="block text-sm font-medium mb-2">Yönetici Notu</label>
            <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={4} data-testid="lead-note-input"
              className="w-full border border-brand-gold-light/50 rounded p-3 text-sm mb-4" />
            <div className="flex gap-3">
              <button onClick={saveNote} data-testid="lead-note-save" className="bg-brand-gold text-brand-offwhite px-6 py-2 rounded-sm text-sm">Kaydet</button>
              <button onClick={() => setSelected(null)} className="border border-brand-gold-light px-6 py-2 rounded-sm text-sm">Kapat</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
